import { render, staticRenderFns } from "./glassEquip.vue?vue&type=template&id=58c3520e&scoped=true&"
import script from "./glassEquip.vue?vue&type=script&lang=js&"
export * from "./glassEquip.vue?vue&type=script&lang=js&"
import style0 from "./glassEquip.vue?vue&type=style&index=0&id=58c3520e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58c3520e",
  null
  
)

export default component.exports